import $ from 'jquery';
import { useSearchParams } from 'react-router-dom';
const ConfigurationError = props => {
  const { error } = props;

  const [searchParams] = useSearchParams();

  return (
    <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <div className="sm:ml-6 flex-col">
            <div className=" sm:border-gray-200 sm:pl-6">
              <p className="text-4xl font-extrabold text-red-900 sm:text-5xl mb-6">
                Configuration Error
              </p>
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Oops! Looks like a configuration error
              </h1>
              <p className="mt-1 text-base text-gray-500 mb-2">
                Please check the configuration of types within the application
              </p>
              {error ? (
                <p className="mt-1 text-base text-red-500 mb-2">{error}</p>
              ) : null}
              <pre
                className="whitespace-normal overflow-x-auto bg-gray-200"
                style={{ height: 300, width: 800 }}>
                {searchParams.get('stack')}
              </pre>
            </div>

            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <a
                href="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-activecourse-orange hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Go back home
              </a>
              <a
                href="#"
                onClick={() => $('#crispChatOpener').click()}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ConfigurationError;
